/**
 * Currently by default WPGraphql 2.1.1 doesn't support orderBy Count
 * We will do it on client
 */
export const getTagsScheme = `
query GetTags {
  tags( first: 99,where: {orderby: COUNT, order:ASC,hideEmpty:true}) {
    nodes {
      name
      count
      slug
    }
  }
}
`;
